// extracted by mini-css-extract-plugin
export default {"Thumbnail":"ArticleThumbnail_Thumbnail__zf60O"};